import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SocoHttpService } from '@app/base/soco';
import { triggerFormValidation, focusFirstInvalidField } from '@app/base/shared';
import {
  ConstantsService, SessionService, RequestStageEnum, RequestStageApprvEnum,
  RequestStageLabelEnum, EnvironmentService, LookupsService
} from '@app/base/core';
import Swal from 'sweetalert2';
import { LandingService, GasRequestStatusViewModel } from '@app/modules/landing/base';
import { AlertService } from '@app/base/alerts/alert.service';

@Component({
  selector: 'app-status',
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.css']
})
export class StatusComponent implements OnInit, OnDestroy {

  private routeSubscription: any;

  // Request Stages Enums
  stageApprvEnum: typeof RequestStageApprvEnum = RequestStageApprvEnum;
  stageEnum: typeof RequestStageEnum = RequestStageEnum;
  stageLabelEnum: typeof RequestStageLabelEnum = RequestStageLabelEnum;
  // Form Group
  requestStatusForm: FormGroup;
  // Request ViewModel
  requestStatus: GasRequestStatusViewModel = null || undefined;
  // Hold the value of active stage 0,1, etc based on conversion of server APPPEN to enum value
  requestActiveStage: number;
  searchId: any;
  // If error happened or request not found, to show no record div
  invalidRequest = false;
  alertMsg: any = [];
  showAlert: boolean = false;
  projectCreationStatusData: any[] = [];
  constructor(
    private route: ActivatedRoute,
    public constantsSvc: ConstantsService,
    public environmentSvc: EnvironmentService,
    private landingSvc: LandingService,
    private socoHttp: SocoHttpService, public lookupSvc: LookupsService,
    public sessionSvc: SessionService, private alertService: AlertService,
    private router: Router) { }

  // Form Properties
  get requestId() { return this.requestStatusForm.get('requestId').value; }
  get captcha() { return this.requestStatusForm.get('recaptcha'); }

  ngOnInit() {
    // Loads common lookup values
    const subscribe = this.lookupSvc.commonLookupsLoaded$.subscribe(val => {
      if (subscribe && val) {
        subscribe.unsubscribe();
      }
      // Banner message for Gas Request Status
      if (val) {
        this.alertMsg = (this.lookupSvc.bannerMessages.find(x => x.itemName === 'Gas Request Status'
        ));
        this.alertService.info(this.alertMsg.message);
      }
    });
    this.requestStatusForm = new FormGroup({  // Init form
      requestId: new FormControl('', [Validators.required, Validators.pattern(this.constantsSvc.numericPattern)]),
      recaptcha: new FormControl('', Validators.required)
    }, { updateOn: 'blur' });

    // Get status ID from route params.
    this.routeSubscription = this.route.params.subscribe(params => {
      if (params['id']) {
        this.requestStatusForm.controls['requestId'].patchValue(params['id']);
      }
    });
    this.requestStatusForm.controls['recaptcha'].valueChanges.subscribe(recaptcha => {
      this.requestStatusForm.updateValueAndValidity();
      if (recaptcha && this.requestStatusForm.valid) { this.submitForm(); }
    });
    //getting holiday list
    this.getHolidayList();
  }

  ngOnDestroy() {
    this.routeSubscription.unsubscribe();
  }
  // Submit form to get applicant request status
  submitForm() {
    if (this.requestStatusForm.valid) {
      this.searchId = this.requestId;
      this.requestStatus = null || undefined;
      this.invalidRequest = false;
      this.requestActiveStage = 0;
      this.landingSvc.getBcaStatusById(this.requestId).subscribe(result => {
        if (result.data === undefined) {
          this.invalidRequest = true;
        } else {
          this.requestStatus = result.data;
          if ((Object.keys(RequestStageApprvEnum).map(e => RequestStageApprvEnum[e])
            .indexOf(this.requestStatus.requestStatus.trim().toUpperCase()) >= 0)) {
            this.requestActiveStage = RequestStageApprvEnum[this.requestStatus.requestStatus];
          } else { throw new Error(this.constantsSvc.unknownRequest + this.requestStatus.requestStatus); }
        }
      }, error => {
        this.invalidRequest = true;
        if (this.socoHttp.isErrorResult(error)) {
          this.invalidRequest = true;
        }
      },
      );

    } else {
      triggerFormValidation(this.requestStatusForm);
      focusFirstInvalidField(this.requestStatusForm);
    }
  }
  // Navigation to Contract Page
  generateContract() {
    this.sessionSvc.sourceToContract = this.constantsSvc.ApplicantUser;
    this.router.navigate(['/', this.sessionSvc.paramLdc.toLocaleLowerCase(), 'builder', 'contract',
      this.constantsSvc.ApplicantUser], this.requestId);
  }
  //CXCO 788 -06/06/2024 Navigation to Service Tracker Page --Srinivas
  myProject() {
     if (this.requestStatusForm.valid) {
    this.searchId = this.requestId;
    this.invalidRequest = false;
    this.landingSvc.getBcaStatusById(this.requestId).subscribe(result => {
      if (result.data === null) {
        this.invalidRequest = true;
      }
      else {
        const projectCancelYN = result.data.projectCancelYN;
        const projectIsActiveYN = result.data.projectIsActiveYN;
        const projectCompletion = result.data.projectCompletion;
        if (projectCancelYN === 'N' && projectIsActiveYN !== '30 DAYS EXCEEDED' && projectCompletion === 'C') {
          localStorage.setItem('serviceTrackerData', JSON.stringify(result.data));
          this.router.navigate(['/', this.sessionSvc.paramLdc.toLocaleLowerCase(), 'serviceTracker']);
        }
        else if (projectCancelYN === 'Y') {
          // Display alert
          this.showCancelledPopup();
        }
        else if (projectIsActiveYN === '30 DAYS EXCEEDED') {
          this.showProjectCompleteAlert();
        }
        else if (projectCompletion === 'P') {
          this.showApplicationNotReceivedPopup();
        }

      }
    }
      , error => {
        this.invalidRequest = true;
        if (this.socoHttp.isErrorResult(error)) {
          this.invalidRequest = true;
        }
      });
     } else {
       triggerFormValidation(this.requestStatusForm);
       focusFirstInvalidField(this.requestStatusForm);
     }
  }


  showApplicationNotReceivedPopup() {
    Swal.fire({
      icon: 'info',
      title: 'Application Pending. Please check back',
      confirmButtonText: 'OK'
    });
  }

  showCancelledPopup() {
    Swal.fire({
      title: 'Project is Cancelled',
      icon: 'error',
      confirmButtonText: 'OK',
      timer: 20000,
    });
  }

  showProjectCompleteAlert() {
    Swal.fire({
      title: 'Completed Projects > 30 Days will not display results',
      icon: 'info',
      confirmButtonText: 'OK'
    });
  }

  //get holiday list data
  getHolidayList() {
    this.landingSvc.getHolidayList().subscribe(result => {
      localStorage.setItem('holidaysData', JSON.stringify(result.data))
    });
  }




}
